<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs />
          <div class="table-agile-info" v-loading="loading">
            <!-- 芥末、前程日本查看，状态:-1，0,1,2 -->
            <div class="common-new-title mode2">
              <span>佣金报帐</span>
              &nbsp; &nbsp;
              <a href="https://www.safe.gov.cn"
                 target="_blank"
                 style="color:green;margin-left:20px">
                <i class="el-icon-date"></i> 查询当月汇率
              </a>
            </div>
            <el-row class="info-manag-wrap">
              <el-col :lg="8" :md="12" :sm="24">
                <label>报帐ID:</label>
                <span>
                  <el-tag><strong>#{{ id }}</strong></el-tag>
                </span>
              </el-col>
              <el-col :lg="16" :md="12" :sm="24">
                <label>发起人:</label>
                <el-select
                  v-if="formData.finance_status !== 1 && ($hasPermission(1) || !formData.creator_uid || !formData.creator_name)"
                  v-model="formData.creator_uid"
                  filterable
                  clearable
                  class="jm-input220"
                  placeholder="请选择">
                  <el-option-group
                    v-for="(group, k) in searchDs.create_list"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      v-show="item.userid > 0"
                      :key="item.userid"
                      :label="item['username']"
                      :value="item['userid']"/>
                  </el-option-group>
                </el-select>
                <span v-else>{{ formData.creator_uid ? formData.creator_name : '-' }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>合作方:</label>
                <span v-if="formData.finance_status === 1">{{ formData.partner_name }}</span>
                <template v-else>
                  <el-autocomplete
                    v-if="formData.project_id === 1213"
                    clearable
                    class="jm-input220"
                    v-model="formData.partner_name"
                    :trigger-on-focus="false"
                    :fetch-suggestions="searchPartnerSchool"
                    placeholder="请输入"
                    @select="handlePartnerSelect"
                  ></el-autocomplete>
                  <el-input
                    v-else
                    clearable
                    v-model="formData.partner_name"
                    :disabled="!formData.project_id"
                    class="jm-input220"
                    placeholder="请输入">
                  </el-input>
                </template>
              </el-col>
              <el-col :lg="16" :md="12" :sm="24">
                <label>费用类型:</label>
                <span>{{ formData.commission_kind_str }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>支付金额:</label>
                <span class="total_amount">{{ formData.total_amount }}</span>
              </el-col>
              <el-col :lg="16" :md="12" :sm="24">
                <label>平台部门:</label>
                <span>{{ formData.project_name }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>支付币种:</label>
                <span>{{ formData.currency_type_str }}</span>
              </el-col>
              <el-col :lg="16" :md="12" :sm="24">
                <label>收款账户:</label>
                <span>{{ formData.payment_method_str }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>外币金额:</label>
                <span v-if="hideRealAmount">-</span>
                <span v-else class="real_amount">{{ formData.real_amount }}</span>
              </el-col>
              <el-col :lg="8" :md="12" :sm="24">
                <label>收款时间:</label>
                <span>{{ formData.receive_time }}</span>
              </el-col>
              <el-col :span="24">
                <label>报帐备注:</label>
                <div v-if="formData.finance_status === 1" class="jm-input500 el-textarea pre">{{ formData.commission_memo }}</div>
                <el-input
                  v-else
                  style="vertical-align: top"
                  resize="none"
                  type="textarea"
                  rows="5"
                  v-model="formData.commission_memo"
                  class="jm-input400">
                </el-input>
              </el-col>
              <el-col :span="24" style="padding: 20px 0">
                <label class="text-point">业务附件:</label>
                <div v-if="formData.finance_status === 1" class="upload-button display-inlineblock">
                  <ul class="el-upload-list el-upload-list--text">
                    <li v-for="(file, index) in formData.business_file" :key="file.uid" :tabindex="index" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name" @click="handelUploadPreview(file)">
                        <i class="el-icon-document"></i>
                        {{ file.name }}
                      </a>
                    </li>
                  </ul>
                </div>
                <jm-upload
                  v-else
                  class="upload-button display-inlineblock"
                  action="/newfib.php/finance/commission/uploadOnlineFile"
                  :file-list="formData.business_file"
                  :on-preview="handelUploadPreview"
                  :on-remove="businessUploadRemove"
                  :on-success="businessUploadSuccess"
                  :show-file-list="true">
                  <el-button size="small" type="primary">上传文件</el-button>
                </jm-upload>
              </el-col>
              <el-col :span="24">
                <label>返佣明细:</label>
                <div style="width:80%" class="display-inlineblock">
                  <el-table
                    v-if="formData.finance_status === 1"
                    :key="1"
                    size="small"
                    :data="formData.commission_details"
                    style="width: 100%">
                    <el-table-column prop="dept_name" label="部门" />
                    <el-table-column prop="commission_type_str" label="费用类型" />
                    <el-table-column prop="dept_total_amount" label="支付金额" />
                    <el-table-column prop="dept_real_amount" label="外币金额" />
                  </el-table>
                  <el-table
                    v-else
                    :key="0"
                    size="small"
                    :data="formData.commission_details"
                    style="width: 100%">
                    <el-table-column prop="dept_name" label="部门">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.dept_id">
                          <el-option :value="12" label="芥末留学" />
                          <el-option :value="13" label="前程日本" />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="commission_type_str" label="费用类型">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.commission_type">
                          <el-option v-for="item in searchDs.commission_type" :value="item.id" :label="item.value" :key="item.id" />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dept_total_amount" label="支付金额">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.dept_total_amount" controls-position="right" style="width:130px" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="dept_real_amount" label="外币金额">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.dept_real_amount" controls-position="right" style="width:130px" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot="header">
                        <el-button size="small" type="primary" circle icon="el-icon-plus" title="创建报帐详情" @click="createDetailItem" />
                      </template>
                      <template slot-scope="scope">
                        <el-button type="text" @click="dropDetailItem(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="border"></div>
                <label>财务附件:</label>
                <div class="upload-button display-inlineblock">
                  <ul class="el-upload-list el-upload-list--text">
                    <li v-for="(file, index) in formData.finance_file" :key="file.uid" :tabindex="index" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name" @click="handelUploadPreview(file)">
                        <i class="el-icon-document"></i>
                        {{ file.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </el-col>

              <el-col :span="24">
                <label>审核状态:</label>
                <el-tag :type="tagColors[formData.finance_status]">
                  {{ formData.finance_status_str }}
                  <!-- : {{ formData.finance_status }} -->
                </el-tag>
              </el-col>

              <el-col :span="24" v-if="formData.finance_status === 1">
                <label>到账日期:</label>
                <span>{{ formData.verify_time }}</span>
              </el-col>

              <el-col :span="24" v-if="formData.finance_status > 0">
                <label>审核备注:</label>
                <div class="jm-input500 el-textarea pre">{{ formData.verify_message }}</div>
              </el-col>
            </el-row>

            <!-- 操作按钮 -->
            <div class="jm-button-wrap jm-tac">
              <el-button v-if="formData.finance_status !== 1" type="primary" @click="saveCommission()" :loading="btnLoading">
                修改订单
              </el-button>
              <el-button v-if="formData.finance_status === -1 || formData.finance_status === 2" type="success" @click="saveCommission({ submit: 1 })" :loading="btnLoading">
                提交审核
              </el-button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="fileImageDialogVisible" :width="fileImageWidth" :show-close="false" custom-class="imagePreview">
      <img :src="fileImageUrl" :title="fileImageName" width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import 'element-ui/lib/theme-chalk/display.css';
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatSelectGroupData, checkImageUrl } from '@/utils/utils.js';
import _ from 'lodash';

const tagColors = {
  2: 'danger',
  1: 'success',
  0: 'warning',
};

export default {
  data() {
    return {
      tagColors,
      btnLoading: false,
      loading: true,
      searchDs: {
        create_list: []
      },
      formData: {
        id: 0,
        submit: 0, // 是否提交保存
        finance_status: -1,
        finance_status_str: '待补全',
      },
      lastPartnerData: {
        id: 0,
        value: ''
      },
      /* 图片预览 */
      fileImageDialogVisible: false,
      fileImageUrl: '',
      fileImageName: '',
      fileImageWidth: '65%'
    };
  },
  computed: {
    id() {
      if (this.$route.params === undefined) {
        return false;
      }
      return this.$route.params.id;
    },
    hideRealAmount() {
      return this.formData.currency_type === '' || this.formData.currency_type === 1;
    }
  },
  methods: {
    dropDetailItem(key) {
      this.formData.commission_details = this.formData.commission_details.filter((item, index) => {
        return index !== key;
      });
    },
    createDetailItem() {
      let totalAmount = Number(this.formData.total_amount) - _.sumBy(this.formData.commission_details, 'dept_total_amount');
      let realAmount = Number(this.formData.real_amount) - _.sumBy(this.formData.commission_details, 'dept_real_amount');
      this.formData.commission_details.push({
        cid: '',
        commission_type: '',
        dept_id: '',
        dept_total_amount: totalAmount > 0 ? totalAmount.toFixed(2) : 0,
        dept_real_amount: realAmount > 0 ? realAmount.toFixed(2) : 0,
      });
    },
    // 订单保存
    saveCommission(data) {
      this.formData = Object.assign({}, this.formData, data || {});

      const msg = this.formData.submit ? '已提交财务审核，请等待' : '保存成功';

      this.btnLoading = true;
      this.$http
        ._post({
          url: '/index/commission/editCommission',
          data: this.formData
        })
        .then(() => {
          this.$router.push('/payment/commissionList');
          this.$message.success(msg);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 获取页面数据
    getFormData(commissionId) {
      this.$http
        ._post({
          url: '/index/commission/find',
          data: { id: commissionId }
        })
        .then((res) => {
          this.formData = res.data;
          this.lastPartnerData = {
            id: this.formData.partner_id,
            value: this.formData.partner_name
          };
          // 更新字典
          this.getSearchDs(this.formData.project_id);
        })
        .catch(() => {
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        });
    },
    getSearchDs() {
      this.$http._post({
        url: '/finance/commission/searchDs',
        data: { projectId: 12 }
      }).then(({ data }) => {
        this.loading = false;
        this.searchDs = data;
        this.searchDs.create_list = formatSelectGroupData(data.create_list);
      });
    },
    businessUploadSuccess(response, file, fileList) {
      if (response.result === -1) {
        this.$message.error(response.msg);
        this.formData.business_file = fileList.filter((f) => {
          return f.uid !== file.uid;
        });
      } else {
        this.formData.business_file.push({
          url: response.data.url,
          name: response.data.name,
          path: response.data.path,
        });
      }
    },
    businessUploadRemove(file, fileList) {
      this.formData.business_file = fileList;
    },
    handelUploadPreview(file) {
      if (!checkImageUrl(file.url)) {
        this.downloadFile(file);
      } else {
        this.previewImage(file);
      }
    },
    changeCurrencyType() {
      if (this.hideRealAmount) {
        this.formData.real_amount = '';
      }
    },
    // 合作方
    handlePartnerSelect(item) {
      this.formData.partner_id = item.id;
      this.lastPartnerData = {
        id: item.id,
        value: item.value
      };
    },
    searchPartnerSchool(query, cb) {
      this.$http
        ._post({
          url: '/finance/commission/searchSchool',
          data: { keyword: query }
        })
        .then(({ data }) => {
          cb(data);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 文件类型
    checkImageUrl(fileUrl) {
      return checkImageUrl(fileUrl);
    },
    // 下载文件
    downloadFile(file) {
      this.$message.success(`附件"${file.name}"下载完成`);
      this.$http.getFile({
        url: file.url,
        filename: file.name
      });
    },
    // 预览图片
    previewImage(file) {
      this.fileImageDialogVisible = true;
      this.fileImageName = file.name;
      this.fileImageUrl = file.url;
      this.fileImageWidth = '60%';
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  mounted() {
    if (!this.id) {
      this.$message.error('参数错误');
      setTimeout(() => {
        this.$router.back();
      }, 1000);
    }
    this.getFormData(this.id);
  },
  watch: {
    'formData.partner_name': {
      handler: function (v) {
        if (this.lastPartnerData.value === v) {
          this.formData.partner_id = this.lastPartnerData.id;
        } else {
          this.formData.partner_id = 0;
        }
      },
      deep: true
    },
  }
};
</script>
<style scoped>
</style>
<style>
  .border{
    border-top:1px dashed #ccc;
    margin:10px 40px;
  }
  .info-manag-wrap .el-col {
    min-height: 41px;
    line-height: 36px;
    margin-bottom: 4px;
  }
  .info-manag-wrap .el-col > label {
    min-width: 100px;
    text-align: right;
    margin: 0 14px 0 0;
    font-weight: 900;
    font-size: 12px;
    display: inline-block;
  }
  .pre {
    vertical-align: top;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .total_amount{
    font-weight: bold;
    font-size: 16px;
    color: green;
  }
  .real_amount{
    font-weight: bold;
    font-size: 16px;
    color: royalblue;
  }
  /* 图片预览 */
  .imagePreview .el-dialog__header {
    display: none;
  }
  .imagePreview .el-dialog__body {
    padding: 2px;
  }
</style>
